import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'
import type { MenuItemType } from '../../frontend-types'
import { MenuItemLink } from './MenuItemLink'

type MenuLinkProps = ComponentProps<'li'> & {
	menuItem: MenuItemType
	underline?: boolean
}

export const MenuLink: FC<MenuLinkProps> = ({ menuItem, underline = true, ...props }) => {
	const { title, href, target } = menuItem
	return (
		<li {...props}>
			<MenuItemLink href={href} target={target} className="w-fit group">
				<span
					className={cx(
						'text-button relative',
						underline &&
							"after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:opacity-0 after:h-px  after:transition-all after:duration-200 after:ease-in-out after:bg-blue-tint-20 group-active:after:bg-white group-hover:after:opacity-100 group-active:after:opacity-100",
					)}
				>
					{title}
				</span>
			</MenuItemLink>
		</li>
	)
}
